<template>
  <!-- 门禁智能系统解决方案 -->
  <div class="content_app">
    <Banner :banner-h="$t('services.rfidTake.title')" :banner-p="$t('services.rfidTake.description')"
            :banner-img="Img1"></Banner>

    <!--    // 产品展示-->
    <scroll-animate >
      <div class="room-architecture-rfid ">
        <div class="architecture_item" v-for="(item,index) in architectureData" :key="index">
        <span class="architecture_item_image_span">
          <img :src="item.image"/>
        </span>
          <h3>
            {{ $t(`services.rfidTake.architecture.${item.key}.title`) }}
          </h3>
          <p class="architecture_item_text">
            {{ $t(`services.rfidTake.architecture.${item.key}.description`) }}
          </p>
        </div>
      </div>
    </scroll-animate>

    <scroll-animate>
      <div class="product_hardware">
        <h1>{{ $t('services.rfidTake.productHardware') }}</h1>
        <p>{{ $t('services.rfidTake.productHardwareDesc') }}</p>
      </div>
    </scroll-animate>

    <scroll-animate>
      <div class="system_service_introduced">
        <img src="@/assets/img/index/fangan/index_jiejue6.png" class="width-auto" style="max-height: 500px; width: auto"/>
      </div>
    </scroll-animate>

    <scroll-animate>
      <div class="product_hardware">
        <h1>{{ $t('services.rfidTake.productHardware1') }}</h1>
        <p>{{ $t('services.rfidTake.productHardwareDesc1') }}</p>
      </div>
    </scroll-animate>
    <scroll-animate>
      <div class="involved_products" style="padding-bottom: 5rem; font-size: 18px;">
        <!--      <h1>{{ $t('services.rfidTake.productHardware0') }}</h1>-->
        <img src="@/assets/img/service/access/rfidCwg.png"/>
      </div>
    </scroll-animate>
  </div>

</template>

<script>
import Banner from "@/components/banner.vue";
import ScrollAnimate from "../../components/ScrollAnimate.vue";

export default {
  components: {ScrollAnimate, Banner},
  mounted() {
  },
  methods: {},
  data() {
    return {
      Img1: require("@/assets/img/banner-bg/shanmai1.jpg"),
      architectureData: [
        // {
        //   image: require("@/assets/img/service/access/rfid/rfid_label_printing.png"),
        //   key: "labelPrint"
        // },
        // {
        //   image: require("@/assets/img/service/access/rfid/rfid_read.png"),
        //   key: "rfidRead"
        // },
        // {
        //   image: require("@/assets/img/service/access/rfid/rfid_antenna.png"),
        //   key: "rfidAntenna"
        {
          image: require("@/assets/img/service/access/rfid/rfid_handheld_terminal.png"),
          key: "handheldTerminal"
        },
      ]
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/css/serviceCommonCss";

.rfid-sys-img {
  max-height: 500px !important;
}

.room-architecture-rfid {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  margin: 0 0 90px 0;
  background-color: white;
  padding: 4rem 0;

  .architecture_item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 400px;
    margin-top: 4rem;
    background-color: rgba(0, 0, 0, .1);
    padding: 2rem;
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);

    .architecture_item_image_span {
      width: 95%;
      height: 230px;
      border-radius: 15px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    h3 {
      color: $shen_green;
      text-align: center;
      font-size: 34px;
      margin: 10px 0;
    }

    .architecture_item_text {
      font-size: 18px;
      text-align: center;
      word-wrap: break-word;
      line-height: 1.6;
    }
  }
}
</style>
